<div class="card-container">
  <div class="unlock">
    <h6>{{title}}</h6>
  </div>
  <!--border -->
  <div class="star-img">
    <img class="starimg" src="../../../assets/images/lucky_star_svg.svg">
  </div>
  <div class="mark-lucky">
    <p>{{description}}</p>
  </div>
  <div class="choose-btn">
    <button (click)="openLuckyNumbersLockedPopup()">
      @if (isConfirm) {
        <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
        style="color: white; margin-right: 1vh"></ion-spinner>
      }
      {{confirmButton}}
    </button>
  </div>
  <div class="decline_btn">
    <span class="no_button" (click)="closePopup()">
      {{changeMyNumber}}
    </span>
  </div>
</div>